import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import _ from "lodash";
import React from "react";
import { t } from "ttag";
import styles from "./SimpleModal.module.css";

type ModalSeverity = "warning" | "danger";

interface IProps {
  showModal: boolean;
  title: string;
  contentText?: string;
  actionName?: string;
  cancelActionName?: string;
  onAction?: () => void;
  closeModal?: () => void;
  children?: any | any[];
  hideBtns?: boolean;
  fullWidth?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  severity?: ModalSeverity;
}

const SEVERITY_COLOR: Record<ModalSeverity, "warning" | "error"> = {
  warning: "warning",
  danger: "error",
};

export default function SimpleModal(props: IProps) {
  if (!props.showModal) {
    return <div />;
  }

  const severityColor = props.severity ? SEVERITY_COLOR[props.severity] : undefined;

  return (
    <Dialog onClose={props.closeModal} aria-labelledby="simple-dialog-title" open={true} fullWidth={props.fullWidth} maxWidth={props.maxWidth}>
      <DialogTitle className={styles.title} id="simple-dialog-title">
        {severityColor && <WarningAmberIcon color={severityColor} />}
        {props.title}
      </DialogTitle>
      <DialogContent className={styles.content}>
        {props.contentText && <Typography>{props.contentText}</Typography>}
        {props.children}
      </DialogContent>
      {!props.hideBtns &&
        <DialogActions>
          <Button onClick={props.closeModal} >
            {props.cancelActionName || t`Cancel`}
          </Button>
          <Button onClick={props.onAction} color={severityColor || "primary"} variant={severityColor ? "contained" : "text"}>
            {props.actionName}
          </Button>
        </DialogActions>
      }
    </Dialog>
  );
}
